
import Button from '../../../components/base/Button';

export default function FeaturedNewsSection() {
  const featuredArticle = {
    title: "Federal Government Announces $2.3 Billion Investment in Rural Healthcare Infrastructure",
    summary: "Historic funding will expand pharmacy and veterinary services in underserved communities across Canada, with specific provisions for Indigenous health initiatives and telemedicine expansion.",
    author: "Dr. Sarah Mitchell",
    date: "January 16, 2025",
    readTime: "8 min read",
    category: "Policy",
    image: "https://public.readdy.ai/ai/img_res/58dc6076715e42da14b99f7b9490c407.jpg"
  };

  const breakingNews = [
    {
      title: "Emergency Protocol Updates for Veterinary Pharmacists",
      time: "2 hours ago",
      urgent: true
    },
    {
      title: "New CE Requirements Effective March 2025",
      time: "4 hours ago",
      urgent: false
    },
    {
      title: "CPVA Annual Conference 2025 Registration Opens",
      time: "6 hours ago",
      urgent: false
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Featured Article */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <img
                src={featuredArticle.image}
                alt={featuredArticle.title}
                className="w-full h-64 object-cover object-top"
              />
              <div className="p-8">
                <div className="flex items-center justify-between mb-4">
                  <span className="inline-block bg-red-100 text-red-800 px-4 py-2 rounded-full text-sm font-medium">
                    Featured Story
                  </span>
                  <span className="inline-block bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-xs font-medium">
                    {featuredArticle.category}
                  </span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4 leading-tight">
                  {featuredArticle.title}
                </h2>
                <p className="text-gray-600 mb-6 text-lg leading-relaxed">
                  {featuredArticle.summary}
                </p>
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center space-x-4">
                    <span className="text-sm text-gray-500">By {featuredArticle.author}</span>
                    <span className="text-gray-300">•</span>
                    <span className="text-sm text-gray-500">{featuredArticle.date}</span>
                    <span className="text-gray-300">•</span>
                    <span className="text-sm text-gray-500">{featuredArticle.readTime}</span>
                  </div>
                </div>
                <Button size="lg" className="bg-blue-600 hover:bg-blue-700 whitespace-nowrap">
                  Read Full Article
                </Button>
              </div>
            </div>
          </div>

          {/* Breaking News Sidebar */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-lg p-6">
              <h3 className="text-xl font-bold text-gray-900 mb-6 flex items-center">
                <i className="ri-flashlight-fill text-red-500 mr-2"></i>
                Breaking News
              </h3>
              <div className="space-y-4">
                {breakingNews.map((item, index) => (
                  <div key={index} className="border-b border-gray-200 pb-4 last:border-b-0">
                    <div className="flex items-start space-x-3">
                      {item.urgent && (
                        <span className="inline-block w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0"></span>
                      )}
                      <div className="flex-1">
                        <h4 className="font-semibold text-gray-900 text-sm leading-tight mb-2">
                          {item.title}
                        </h4>
                        <span className="text-xs text-gray-500">{item.time}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Button variant="outline" className="w-full mt-6 whitespace-nowrap">
                View All Breaking News
              </Button>
            </div>

            {/* Quick Links */}
            <div className="bg-blue-50 rounded-xl p-6 mt-6">
              <h3 className="text-lg font-bold text-gray-900 mb-4">Quick Links</h3>
              <div className="space-y-3">
                <a href="#" className="block text-blue-600 hover:text-blue-800 font-medium text-sm">
                  Policy Updates Archive
                </a>
                <a href="#" className="block text-blue-600 hover:text-blue-800 font-medium text-sm">
                  Press Release Library
                </a>
                <a href="#" className="block text-blue-600 hover:text-blue-800 font-medium text-sm">
                  Media Contact Information
                </a>
                <a href="#" className="block text-blue-600 hover:text-blue-800 font-medium text-sm">
                  Newsletter Subscription
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
